// Import monaco-editor so that monaco.editor.create (etc) can be used
import * as monaco from "monaco-editor";

global.monaco = monaco;
